export type UserType = "E" | "F" | "A"

export enum UserTypeEnum {
	STUDENT = "E", /* ESTUDANTE */
	SPONSOR = "F", /* FACULDADE */
	ADMIN = "A" /* ENEMVIP */
}
